export const STEPS = {
  ADD_DETAILS: "ADD_DETAILS",
  MAP_DATA_CONNECTIONS: "MAP_DATA_CONNECTIONS",
  MAP_CATEGORIES: "MAP_CATEGORIES",
  REVIEW: "REVIEW",
} as const;

export type STEPS_TYPE = (typeof STEPS)[keyof typeof STEPS];

export const STEPS_BREADCRUMBS: Array<{
  name: string;
  step: STEPS_TYPE;
  no: number;
}> = [
  { name: "Add details", step: STEPS.ADD_DETAILS, no: 1 },
  { name: "Map data connections", step: STEPS.MAP_DATA_CONNECTIONS, no: 2 },
  { name: "Map categories", step: STEPS.MAP_CATEGORIES, no: 3 },
  { name: "Review", step: STEPS.REVIEW, no: 4 },
];

export const QBO_STEPS = {
  ADD_DETAILS: "ADD_DETAILS",
  MAP_DATA_CONNECTIONS: "MAP_DATA_CONNECTIONS",
  MAP_CATEGORIES: "MAP_CATEGORIES",
  DEFAULT_CATEGORIES: "DEFAULT_CATEGORIES",
  REVIEW: "REVIEW",
} as const;

export type QBO_STEPS_TYPE = (typeof QBO_STEPS)[keyof typeof QBO_STEPS];

export const QBO_STEP_ORDER = Object.values(QBO_STEPS);

export const QBO_STEPS_BREADCRUMBS: Array<{
  name: string;
  step: QBO_STEPS_TYPE;
  no: number;
}> = [
  { name: "Add details", step: QBO_STEPS.ADD_DETAILS, no: 1 },
  { name: "Map data connections", step: QBO_STEPS.MAP_DATA_CONNECTIONS, no: 2 },
  { name: "Map categories", step: QBO_STEPS.MAP_CATEGORIES, no: 3 },
  { name: "Default categories", step: QBO_STEPS.DEFAULT_CATEGORIES, no: 4 },
  { name: "Review", step: QBO_STEPS.REVIEW, no: 5 },
];

export const IMPORT_SOURCE = {
  FINALLY: "FINALLY",
  QBO: "QBO",
} as const;

export type ImportSource = (typeof IMPORT_SOURCE)[keyof typeof IMPORT_SOURCE];

export const IMPORT_SOURCE_LABEL: Record<ImportSource, string> = {
  [IMPORT_SOURCE.FINALLY]: "Finally",
  [IMPORT_SOURCE.QBO]: "Quickbooks",
};

export const REQUIRED_IMPORT_DEFAULT_CATEGORIES = [
  "ACCOUNTS_RECEIVABLE",
  "ACCOUNTS_PAYABLE",
  "DISCOUNTS",
];
